import { dispatch } from '@src/dispatcher';

import ACTION_TYPES from './actionTypes';
import * as Api from './api';
import Store from './store';
import { prettifyOutput } from '../utils/const';

const { getStateImmutable } = Store;

export function createNewCodeNode(substoryId, domainTitle, cb = () => {}) {
  const store = getStateImmutable();
  const data = {};
  data.title = store.title;
  data.pos_x = store.posX;
  data.pos_y = store.posY;
  data.active = store.active;
  data.sub_story_id = substoryId;
  data.domain_name = domainTitle;
  data.custom_code_block_edited = true;

  return new Promise(async (resolve, reject) => {
    try {
      const codeNodeResponse = await Api.createNewCodeNode(data);
      dispatch(ACTION_TYPES.SAVE_CODENODE_DATA);

      resolve(codeNodeResponse);
      cb(true, codeNodeResponse.body.id);
    } catch (e) {
      cb(false, e);
      reject(e);
    }
  });
}

export function fetchCodeNodeData(id, cb = () => {}) {
  return new Promise(async (resolve) => {
    try {
      const codeNodeResponse = await Api.fetchCodeNodeData(id);

      dispatch(ACTION_TYPES.RECEIVED_CODENODE_DATA, {
        title: codeNodeResponse.body.title,
        posX: codeNodeResponse.body.pos_x,
        posY: codeNodeResponse.body.pos_y,
        active: codeNodeResponse.body.active,
        outputJSON: JSON.stringify(codeNodeResponse.body.output_json, null, 2),
        inputJSON: JSON.stringify(codeNodeResponse.body.input_json, null, 2),
        code: codeNodeResponse.body.custom_code_block,
        functionName: codeNodeResponse.body.function_name,
        lastEditedTime: codeNodeResponse.body.last_edited_time,
      });

      resolve(codeNodeResponse);
      cb();
    } catch (e) {
      cb('Error! There was a problem in completing your request');
    }
  });
}

export function updateCodeNodeData(key, value) {
  const store = getStateImmutable();
  const updatedStore = store.set(key, value);
  dispatch(ACTION_TYPES.UPDATE_CODENODE_DATA, updatedStore);
}

export function updateEditorData(key, value) {
  const store = getStateImmutable();
  const updatedStore = store.set(key, value);
  dispatch(ACTION_TYPES.UPDATE_EDITOR_DATA, updatedStore);
}

export function saveCodeNodeData(id, code, cb = () => {}, domainTitle = '') {
  const store = getStateImmutable();
  const data = {};

  let { outputJSON } = store;

  try {
    outputJSON = JSON.parse(outputJSON);
  } catch (e) {
    cb('Error! Output JSON format is invalid');

    return null;
  }

  data.title = store.title;
  data.pos_x = store.posX;
  data.pos_y = store.posY;
  data.active = store.active;
  data.custom_code_block = code || store.code;
  data.output_json = outputJSON;
  // we want this flag to be true if code is edited in the code node.
  // Since we pass code directly to the api from the code editor container
  // we can base our check on code parameter of the function
  // TRUE -- When code parameter is present.
  // FALSE - when code parameter is not present.
  data.custom_code_block_edited = !!code;

  return new Promise(async (resolve, reject) => {
    try {
      const codeNodeResponse = await Api.saveCodeNodeData(
        id,
        data,
        domainTitle
      );
      dispatch(ACTION_TYPES.SAVE_CODENODE_DATA);

      const storeX = getStateImmutable();
      const updatedStore = storeX
        .set('functionName', codeNodeResponse.body.function_name)
        .set(
          'inputJSON',
          JSON.stringify(codeNodeResponse.body.input_json, null, 2)
        );
      dispatch(ACTION_TYPES.UPDATE_EDITOR_DATA, updatedStore);

      resolve(codeNodeResponse);
      cb();
    } catch (e) {
      cb(e || 'Error! There was a problem in completing your request');
      reject(e);
    }
  });
}

export function resetCodeNodeData(cb = () => {}) {
  dispatch(ACTION_TYPES.RESET_CODENODE_DATA);
  cb();
}

export function setCodeNodeCoords(x, y, cb = () => {}) {
  const storeX = getStateImmutable();
  const updatedStore = storeX.set('posX', x).set('posY', y);
  dispatch(ACTION_TYPES.SET_CODENODE_COORDS, updatedStore);

  cb();
}

export function toggleCodeNode(id, toggle, cb = () => {}) {
  const data = {};
  data.active = toggle;

  return new Promise(async (resolve) => {
    try {
      const codeNodeResponse = await Api.saveCodeNodeData(id, data);
      resolve(codeNodeResponse);
      cb();
    } catch (e) {
      cb('Error! There was a problem in completing your request');
    }
  });
}

export function runCodeNodeData(functionName, inputJSON, cb = () => {}) {
  return new Promise(async (resolve) => {
    let runJSON;

    try {
      runJSON = JSON.parse(inputJSON);
    } catch (e) {
      cb(false, 'Error! Input JSON format is invalid');
      return;
    }

    try {
      const runCodeResponse = await Api.runCodeNodeData(functionName, runJSON);
      resolve(runCodeResponse);

      cb(true, prettifyOutput(runCodeResponse));
    } catch (e) {
      cb(false, 'ERROR! TRY AGAIN');
    }
  });
}

export function fetchEnvVariables(domainId, cb = () => {}) {
  return new Promise(async (resolve, reject) => {
    try {
      const envResponse = await Api.fetchEnvVariables(domainId);

      dispatch(ACTION_TYPES.SET_ENV_VARIABLES, {
        envVariables: envResponse.body.env_variables,
      });

      resolve(envResponse);

      /**
       *  callback with env variables is just for STATIC NODE @TO_BE_REMOVED
       */

      cb(true, envResponse.body.env_variables);
    } catch (e) {
      cb(false, e);
      reject(e);
    }
  });
}

export function saveEnvVariables(domainId, envVariables, cb = () => {}) {
  const data = {
    env_variables: envVariables,
  };

  return new Promise(async (resolve, reject) => {
    try {
      const envResponse = await Api.saveEnvVariables(domainId, data);

      dispatch(ACTION_TYPES.SET_ENV_VARIABLES, {
        envVariables,
      });

      resolve(envResponse);
      cb();
    } catch (e) {
      cb('Error! There was a problem in completing your request');
      reject(e);
    }
  });
}

export function resetEnvVariables() {
  dispatch(ACTION_TYPES.RESET_ENV_VARIABLES);
}
